import React, { useState, useEffect } from 'react';

import { Outlet } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import Header from '../Layout/Header';
import Sidebar from '../Layout/Sidebar';
import SecondarySidebar from '../Layout/SecondarySidebar';

import { useUiStore } from '../../store';

export default function Layout() {
  const [isSecondarySidebarOpen, setIsSecondarySidebarOpen] = useState(true);

  const headerHeight = useUiStore((state) => state.headerHeight);
  const sidebarWidth = useUiStore((state) => state.sidebarWidth);

  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });

  useEffect(() => {
    var hideSideNavButtonEl = document.getElementById(
      'show-secondary-sidenav-button'
    );
    var showSideNavButtonEl = document.getElementById(
      'hide-secondary-sidenav-button'
    );
    var sidenavEl = document.getElementById('secondary-sidenav');

    // learn more about the Drawer object: https://flowbite.com/docs/components/drawer/#javascript-behaviour
    // eslint-disable-next-line no-undef
    var sideNav = new Drawer(sidenavEl, {
      backdrop: false,
      bodyScrolling: true,
      onHide: function () {
        showSideNavButtonEl.classList.remove('hidden');
        hideSideNavButtonEl.classList.add('hidden');
        setIsSecondarySidebarOpen(false);
      },
      onShow: function () {
        showSideNavButtonEl.classList.add('hidden');
        hideSideNavButtonEl.classList.remove('hidden');
        setIsSecondarySidebarOpen(true);
      },
    });

    // show by default
    sideNav.show();

    hideSideNavButtonEl.addEventListener('click', function () {
      sideNav.hide();
    });

    showSideNavButtonEl.addEventListener('click', function () {
      sideNav.show();
    });
  }, []);

  return (
    <div className="bg-gray-50 dark:bg-gray-900 antialiased">
      <Header />

      <aside
        id="sidebar-double"
        className="flex z-40 fixed top-[3.5rem] left-0 h-full transition-transform -translate-x-full lg:translate-x-0"
        aria-label="Sidebar"
      >
        <Sidebar />
        <SecondarySidebar isSecondarySidebarOpen={isSecondarySidebarOpen} />
        <button
          id="hide-secondary-sidenav-button"
          aria-controls="secondary-sidenav"
          type="button"
          className="inline-flex absolute bottom-16 left-20 p-2 text-gray-500 rounded-full cursor-pointer dark:text-gray-400 hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-700 dark:bg-gray-900 dark:hover:text-white bg-white hidden"
        >
          <svg
            className="w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
      </aside>

      <div
        style={{
          paddingTop: headerHeight,
          paddingLeft: isMobile ? 0 : sidebarWidth,
        }}
        className="transition-all duration-300 ease-in-out h-[100dvh]"
      >
        <Outlet />
      </div>
    </div>
  );
}
